var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35254 22.3383C5.35254 21.3718 6.13604 20.5883 7.10254 20.5883H49.1026C50.0691 20.5883 50.8526 21.3718 50.8526 22.3383C50.8526 23.3048 50.0691 24.0883 49.1026 24.0883H7.10254C6.13604 24.0883 5.35254 23.3048 5.35254 22.3383Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8651 7.10082C34.5485 6.4174 35.6566 6.4174 36.34 7.10082L50.34 21.1008C51.0234 21.7842 51.0234 22.8923 50.34 23.5757C49.6566 24.2591 48.5485 24.2591 47.8651 23.5757L33.8651 9.57569C33.1817 8.89228 33.1817 7.78424 33.8651 7.10082Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28469 34.0049C6.28469 33.0384 7.0682 32.2549 8.03469 32.2549H50.0347C51.0012 32.2549 51.7847 33.0384 51.7847 34.0049C51.7847 34.9714 51.0012 35.7549 50.0347 35.7549H8.03469C7.0682 35.7549 6.28469 34.9714 6.28469 34.0049Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79723 32.7675C7.48065 32.0841 8.58869 32.0841 9.27211 32.7675L23.2722 46.7675C23.9556 47.4509 23.9556 48.5589 23.2722 49.2424C22.5888 49.9258 21.4807 49.9258 20.7973 49.2424L6.79724 35.2424C6.11382 34.5589 6.11382 33.4509 6.79723 32.7675Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.399c2b62.svg";
export { ForwardRef as ReactComponent };